"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageDetailType = exports.pageNameV1 = void 0;
exports.pageNameV1 = {
    '/': 'vertical_main',
    '/list': 'vertical_list',
    '/tour-ticket/list': 'vertical_tour_ticket_list',
    '/domestic-list': 'vertical_domestic_list',
    '/products/:agtName/:productId': 'vertical_detail',
    '/domestic-products/:agtName/:productId': 'vertical_domestic_detail',
    '/redirect': 'vertical_redirect',
    '/domestic-redirect': 'vertical_domestic_redirect',
    '/compare': 'vertical_compare',
    '/compare/:productId': 'vertical_compare',
    '/nx/list': 'nx_list',
};
exports.pageDetailType = {
    '/': 'pkgtour_overseas_home',
    '/list': 'pkgtour_overseas_list',
    '/tour-ticket/list': 'pkgtour_tour-ticket_list',
    '/domestic-list': 'pkgtour_domestic_list',
    '/products/:agtName/:productId': 'pkgtour_overseas_detail',
    '/domestic-products/:agtName/:productId': 'pkgtour_domestic_detail',
    '/redirect': 'pkgtour_overseas_redirect',
    '/domestic-redirect': 'pkgtour_domestic_redirect',
    '/compare': 'pkgtour_overseas_compare',
    '/compare/:productId': 'pkgtour_overseas_compare',
    '/custom-travel/[agtName]/[productId]': 'pkgtour_overseas_custom-travel',
    '/custom-travel/[agtName]/[productId]/estimate': 'pkgtour_overseas_custom-travel',
    '/custom-travel/[agtName]/[productId]/consulting': 'pkgtour_overseas_custom-travel',
    '/custom-travel/[agtName]/[productId]/complete': 'pkgtour_overseas_custom-travel',
    '/custom-travel/estimate/[estimateId]': 'pkgtour_overseas_custom-travel',
    '/brandmall/[agtName]': 'pkgtour_overseas_brandmall',
};
